import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Link, SidebarModal, Text,
} from '@domain-group/suit-theme'

import type { UserModel } from '@domain-group/realhub-backend-api-types'

interface UserProps {
  callbacks: {
    deleteUser: VoidFunction,
  },
  user: UserModel,
}

const User = (props: UserProps) => {
  const {
    callbacks: {
      deleteUser,
    },
    user,
  } = props

  return (
    <SidebarModal.User
      disableHover
      imageUrl={user.image?.square_url || ''}
      // @ts-expect-error TS2322
      subtitle={(
        <Box flexDirection="column">
          <Text color="bodyFontLightColor" fontSize="xsmall">#{user.id}</Text>
          <Text color="bodyFontLightColor" marginTop="small">{user.email}</Text>
        </Box>
      )}
      // @ts-expect-error TS2339
      title={user?.title}
    >
      <Link greyLink onClick={deleteUser}>
        <FontAwesomeIcon icon={faTrashAlt} />
      </Link>
    </SidebarModal.User>
  )
}

export default User
